// =========================================================
// AbdullahStore.shop — Shopify Theme Scripts
// =========================================================

// ---- Flash deal countdown ----
function startCountdown(){
  const wrap = document.getElementById('flashCountdown');
  if(!wrap) return;
  const hours = parseInt(wrap.getAttribute('data-hours') || '62', 10);
  let end = new Date();
  end.setHours(end.getHours() + hours);

  function tick(){
    const now = new Date();
    let diff = Math.max(0, end - now);
    const d = Math.floor(diff / (1000*60*60*24));
    const h = Math.floor((diff/(1000*60*60)) % 24);
    const m = Math.floor((diff/(1000*60)) % 60);
    const s = Math.floor((diff/1000) % 60);
    const pad = n => String(n).padStart(2,'0');
    const dEl = document.getElementById('cd-days');
    const hEl = document.getElementById('cd-hours');
    const mEl = document.getElementById('cd-mins');
    const sEl = document.getElementById('cd-secs');
    if(dEl) dEl.textContent = pad(d);
    if(hEl) hEl.textContent = pad(h);
    if(mEl) mEl.textContent = pad(m);
    if(sEl) sEl.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
}

// ---- Back to top ----
function initBackTop(){
  const btn = document.getElementById('backTop');
  if(!btn) return;
  window.addEventListener('scroll', () => {
    if(window.scrollY > 400) btn.classList.add('show');
    else btn.classList.remove('show');
  });
  btn.addEventListener('click', () => window.scrollTo({top:0, behavior:'smooth'}));
}

// ---- Sticky nav shadow on scroll ----
function initScrollShadow(){
  window.addEventListener('scroll', () => {
    document.body.classList.toggle('is-scrolled', window.scrollY > 10);
  }, {passive:true});
}

// ---- Fade-up reveal animation for sections as they enter the viewport ----
function initScrollReveal(){
  const targets = document.querySelectorAll(
    '.hero, .category-grid, .flash-deal, .product-grid, .testimonial-wrap, .newsletter, .contact-layout, .policy-content'
  );
  if(!targets.length) return;
  targets.forEach(el => el.classList.add('reveal-up'));
  if(!('IntersectionObserver' in window)){
    targets.forEach(el => el.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {threshold:0.12});
  targets.forEach(el => observer.observe(el));
}

// ---- Mobile nav toggle ----
function initMobileNav(){
  const toggle = document.getElementById('mobileToggle');
  const nav = document.getElementById('navLinks');
  if(!toggle || !nav) return;
  toggle.addEventListener('click', () => nav.classList.toggle('open'));
}

// ---- Wishlist toggle (visual only — decorative, no backend) ----
function initWishlist(){
  document.querySelectorAll('.wish-btn, .wa-product-card__wishlist').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      btn.classList.toggle('active');
      btn.textContent = btn.classList.contains('active') ? '♥' : '♡';
    });
  });
}

// ---- Dot-paginated carousel (4-per-page, autoplay, play/pause) ----
// Powers the Testimonials + WhatsApp Reviews sections.
function debounce(fn, wait){
  let t;
  return function(){
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, arguments), wait);
  };
}

function initDotCarousel(root){
  if(!root || root.dataset.carouselReady) return;
  const viewport = root.querySelector('[data-carousel-viewport]');
  const track = root.querySelector('[data-carousel-track]');
  const dotsWrap = root.querySelector('[data-carousel-dots]');
  const prevBtn = root.querySelector('[data-carousel-prev]');
  const nextBtn = root.querySelector('[data-carousel-next]');
  const playBtn = root.querySelector('[data-carousel-play]');
  if(!viewport || !track) return;
  const items = Array.prototype.slice.call(track.children);
  if(!items.length) return;

  root.dataset.carouselReady = 'true';

  const autoplayDelay = parseInt(root.getAttribute('data-autoplay-delay') || '4000', 10);
  let perPage = 4;
  let pageCount = 1;
  let current = 0;
  let autoplay = true;
  let timer = null;

  function getPerPage(){
    const w = window.innerWidth;
    if(w < 700) return 1;
    if(w < 990) return 2;
    return 4;
  }

  function updateDots(){
    if(!dotsWrap) return;
    dotsWrap.querySelectorAll('.dot-carousel__dot').forEach((d, i) => {
      d.classList.toggle('is-active', i === current);
    });
  }

  function buildDots(){
    if(!dotsWrap) return;
    dotsWrap.innerHTML = '';
    for(let i = 0; i < pageCount; i++){
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dot-carousel__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', (function(idx){
        return function(){ goTo(idx); restartAutoplay(); };
      })(i));
      dotsWrap.appendChild(dot);
    }
    updateDots();
  }

  function goTo(idx, skipAnim){
    current = ((idx % pageCount) + pageCount) % pageCount;
    const vw = viewport.clientWidth;
    track.style.transition = skipAnim ? 'none' : 'transform .45s ease';
    track.style.transform = 'translateX(-' + (current * vw) + 'px)';
    updateDots();
  }

  function next(){ goTo(current + 1); }
  function prev(){ goTo(current - 1); }

  function stopAutoplay(){
    if(timer) clearInterval(timer);
    timer = null;
  }
  function startAutoplay(){
    stopAutoplay();
    if(!autoplay || pageCount <= 1) return;
    timer = setInterval(next, autoplayDelay);
  }
  function restartAutoplay(){ startAutoplay(); }

  function layout(){
    perPage = getPerPage();
    pageCount = Math.max(1, Math.ceil(items.length / perPage));
    const vw = viewport.clientWidth;
    const itemWidth = vw / perPage;
    items.forEach((item) => {
      item.style.flex = '0 0 ' + itemWidth + 'px';
      item.style.width = itemWidth + 'px';
    });
    if(current > pageCount - 1) current = 0;
    buildDots();
    goTo(current, true);
    startAutoplay();
  }

  if(prevBtn) prevBtn.addEventListener('click', () => { prev(); restartAutoplay(); });
  if(nextBtn) nextBtn.addEventListener('click', () => { next(); restartAutoplay(); });
  if(playBtn){
    playBtn.addEventListener('click', () => {
      autoplay = !autoplay;
      playBtn.classList.toggle('is-paused', !autoplay);
      playBtn.textContent = autoplay ? '❚❚' : '►';
      playBtn.setAttribute('aria-label', autoplay ? 'Pause autoplay' : 'Play autoplay');
      if(autoplay) startAutoplay(); else stopAutoplay();
    });
  }

  layout();
  window.addEventListener('resize', debounce(layout, 200));
}

function initDotCarousels(){
  document.querySelectorAll('[data-dot-carousel]').forEach(initDotCarousel);
}

document.addEventListener('DOMContentLoaded', () => {
  startCountdown();
  initBackTop();
  initMobileNav();
  initWishlist();
  initScrollShadow();
  initScrollReveal();
  initDotCarousels();
});

// Re-init when a section is added/re-rendered in the Theme Editor
document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('[data-dot-carousel]').forEach(initDotCarousel);
});
